import { API_ENDPOINTS, getAuthHeaders } from '../config/api';
import { metadataItemsConstants } from '../_constants';
import { runCachedRequest } from '../_helpers/requestCache';

export const metadataItemsActions = {
    fetchAll
};

function fetchAll() {
    return async dispatch => {
        dispatch(request());

        const headers = getAuthHeaders();

        try {
            const response = await runCachedRequest(
                'metadata-items:all',
                () => fetch(API_ENDPOINTS.METADATA.ITEMS, { headers }),
                { ttl: 5 * 60 * 1000 },
            );
            
            if (!response.ok) {
                throw new Error('Failed to fetch metadata items');
            }

            const metadataItems = await response.json();
            dispatch(success(metadataItems));
            return metadataItems;
        } catch (error) {
            dispatch(failure(error.toString()));
            throw error;
        }
    };

    function request() { return { type: metadataItemsConstants.FETCH_ALL_REQUEST } }
    function success(metadataItems) { return { type: metadataItemsConstants.FETCH_ALL_SUCCESS, metadataItems } }
    function failure(error) { return { type: metadataItemsConstants.FETCH_ALL_FAILURE, error } }
}
